module.exports = __webpack_public_path__ + "static/img/hi.2a9995e9.png";